import React from 'react';
import styles from './HeroSection.module.scss';
import {
  LEAF_4,
  LEAF_3,
  LEAF_2,
} from '../../../../../src/assets/images/footer';
import { Typography } from '@mui/material';

export default function HeroSection({ currentCategory, currentTag }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.mainContainer}>
        <div className={styles.leafContainer}>
          <div className={styles.LeafOne}>
            <LEAF_4 />
          </div>
          <div className={styles.LeafTwo}>
            <LEAF_3 />
          </div>
          <div className={styles.LeafThree}>
            <LEAF_2 />
          </div>
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.heroConent}>
            <Typography variant="h5">
              {currentCategory?.name
                ? currentCategory?.name
                : 'Resource Center'}
            </Typography>
            {currentTag ? (
              <Typography
                variant="h1"
                color="primary"
                className={styles.mainTitleContent}
              >
                Articles with the tag <span>{currentTag.name}</span>
              </Typography>
            ) : (
              <div className={styles.mainHeroContent}>
                <Typography
                  variant="h1"
                  color="primary"
                  className={styles.mainTitleContent}
                >
                  Effective Solutions Come From <span>Effective Research</span>
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
